
import { useFadeInScroll } from "../../components/Animation/fadeinScroll";
const InnovationHero = () => {
   const title = useFadeInScroll<HTMLDivElement>();
  return (
    <section className=" px-6 sm:px-12 lg:px-20  bg-white text-center">
        <div
            ref={title.ref}
            className={`
              transition-all duration-[900ms] ease-[cubic-bezier(0.22,1,0.36,1)]
              ${title.isVisible
                ? "opacity-100 translate-y-0"
                : "opacity-0 translate-y-6"}
            `}
          >
       <h2
          className="
            text-primary font-semibold leading-tight
            text-[1.6rem]
            sm:text-[2.1rem]
            md:text-[2.5rem]
            lg:text-[2.8rem]
            xl:text-[3rem]
            mb-4 sm:mb-5
          "
        >
        What does this mean for you?
      </h2>
</div>
      <p className=" max-w-2xl mx-auto text-gray-500 leading-relaxed">
        It means better outcomes, faster recovery, and care that’s designed
        around you. From advanced orthopedic innovations to expert medical
        insight, everything here focuses on restoring mobility, reducing pain,
        and helping you return to life without limitations.
      </p>
      
    </section>
  );
};

export default InnovationHero;
